import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Col, Row, Table, Button } from "@themesberg/react-bootstrap";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "src/app/contexts/UserContext";
import { routesPath } from "src/app/routes";
import AddEditUserModal from "./AddEditUserModal";
import ProfileCardWidget from "./ProfileCardWidget";

const Users = () => {
	const [selectedUser, setSelectedUser] = useState(-1);
	const [editUserData, setEditUserData] = useState(null);
	const [addEditButtonClicked, setAddEditButtonClicked] = useState(false);
	const {
		userData,
		getAllUsersDataFromContext,
		createUserFromContext,
		updateUserDataFromContext,
		delteUserDataFromContext,
	} = useContext(UserContext);
	const [showAddEditUserModal, setShowAddEditUserModal] = useState(false);

	const handleOnPropertyCountClick = (index) => {
		setSelectedUser(index);
	};

	const handleAddEditCloseButtonClick = (isEditButton) => {
		console.log(selectedUser);
		if (isEditButton) {
			setEditUserData(userData?.filter((user) => user.id === selectedUser)?.[0]);
		} else {
			setEditUserData(null);
		}
		setShowAddEditUserModal(!showAddEditUserModal);
		setSelectedUser(-1);
	};

	const handleDeleteButtonClick = () => {
		console.log(selectedUser);
		delteUserDataFromContext(selectedUser, () => getAllUsersDataFromContext());
		setSelectedUser(-1);
	};

	useEffect(() => {
		getAllUsersDataFromContext();
	}, []);

	console.log(editUserData);

	return (
		<>
			{addEditButtonClicked && (
				<AddEditUserModal
					editUserData={editUserData}
					{...{
						showAddEditUserModal,
						handleAddEditCloseButtonClick,
						getAllUsersDataFromContext,
						createUserFromContext,
						updateUserDataFromContext,
						setAddEditButtonClicked,
					}}
				/>
			)}
			<div className="d-flex justify-content-between align-items-center w-100">
				<Button
					variant="gray"
					className="mt-4 text-light"
					onClick={() => {
						setAddEditButtonClicked(true);
						handleAddEditCloseButtonClick();
					}}
				>
					<FontAwesomeIcon icon={faPlus} className="me-2" />
					Add Users
				</Button>
			</div>
			{userData?.length > 0 && (
				<div className="py-4">
					<Row>
						<Col md={selectedUser === -1 ? 12 : 8}>
							<Card border="light" className="shadow-sm">
								<Card.Body>
									<Table>
										<thead className="thead-dark">
											<tr>
												<th className="border-0">#ID</th>
												<th className="border-0">Name</th>
												<th className="border-0">Email</th>
												<th className="border-0">Phone</th>
											</tr>
										</thead>
										<tbody>
											{userData &&
												userData.map((user) => (
													<tr>
														<td className="border-0 fw-bold">
															{user?.id ?? ""}
														</td>
														<td className="border-0">
															<span
																className="h6 fw-bolder"
																onClick={() =>
																	handleOnPropertyCountClick(
																		user.id
																	)
																}
																style={{ cursor: "pointer" }}
															>
																{user.name}
															</span>
														</td>
														<td className="border-0 fw-bold">
															{user?.email ?? ""}
														</td>
														<td className="border-0 fw-bold">
															{user?.phone ?? ""}
														</td>
													</tr>
												))}
										</tbody>
									</Table>
								</Card.Body>
							</Card>
						</Col>
						{selectedUser !== -1 && (
							<Col md={4}>
								<Row>
									<Col md={12}>
										<ProfileCardWidget
											user={
												userData?.filter(
													(user) => user.id === selectedUser
												)?.[0]
											}
											handleAddEditCloseButtonClick={
												handleAddEditCloseButtonClick
											}
											handleDeleteButtonClick={handleDeleteButtonClick}
											setAddEditButtonClicked={setAddEditButtonClicked}
										/>
									</Col>
								</Row>
								{userData?.filter((user) => user.id === selectedUser)?.[0]
									?.properties?.length > 0 && (
									<Row>
										<Col md={12}>
											<Card border="light" className="shadow-sm">
												<Card.Body>
													<Table style={{ tableLayout: "fixed" }}>
														<thead className="thead-dark">
															<tr>
																<th className="border-0">
																	Property Name
																</th>
															</tr>
														</thead>
														<tbody>
															{userData
																?.filter(
																	(user) =>
																		user.id === selectedUser
																)?.[0]
																?.properties?.map((property) => (
																	<tr>
																		<td
																			style={{
																				textOverflow:
																					"ellipsis",
																				overflow: "hidden",
																			}}
																		>
																			<Link
																				to={
																					routesPath
																						.Properties
																						.path +
																					"/" +
																					property?.id
																				}
																				state={property?.id}
																			>
																				{property.name}
																			</Link>
																		</td>
																	</tr>
																))}
														</tbody>
													</Table>
												</Card.Body>
											</Card>
										</Col>
									</Row>
								)}
							</Col>
						)}
					</Row>
				</div>
			)}
			{userData?.length <= 0 && <center>No Data</center>}
		</>
	);
};

export default Users;
